// modules
import { addModal } from 'weblite-web-modal-viewer'
import { RecommendInstallTwa } from './recommend-install-twa'

const COMPONENT_ID = 'recommendInstallTwa'

export const showRecommendInstallTwaModal = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: RecommendInstallTwa,
  },
}
